export class SlickError extends Error {
  constructor(options) {
    const { cause, message, ...extra } = options ?? {};

    // this is the standard interface
    // noinspection JSCheckFunctionSignatures
    super(message, { cause });

    // with this we can add any extra fields through the constructor
    Object.assign(this, extra);

    // just in case an older browser doesn't add the cause
    if (!this.cause) this.cause = cause;

    if (!this.name || this.name === 'Error') this.name = 'SlickError';
  }
}

export class ApmError extends SlickError {
  constructor(options) {
    super({ ...options, name: 'ApmError' });
  }
}
